import React from "react";
import { Tooltip } from "antd";

import CommonInput from "../../../../components/commonFields";
import { redCrossIcon, TickIcon } from "../../../../assets/svg";

const QuickReplySection = ({
  newTitle,
  newMsg,
  handleTitleChange,
  handleMsgChange,
  saveMsg,
  closeQuickMsgSection,
  quickReplyId = "",
}) => {
  return (
    <section className="quick-reply-section">
      <div className="input-section">
        <div className="input-title">Title</div>
        <CommonInput
          placeholder="Enter New Title"
          className="custom-form-input"
          onChange={handleTitleChange}
          value={newTitle}
        />
      </div>
      <div className="input-section">
        <div className="input-title">Message</div>
        <CommonInput
          type="textarea"
          placeholder="Enter New Message"
          className="custom-form-message"
          onChange={handleMsgChange}
          value={newMsg}
          maxRows={5}
          minRows={5}
        />
      </div>
      <div className="icons">
        <Tooltip title="Save">
          <span onClick={() => saveMsg(quickReplyId)} className="action-icon">
            <TickIcon />
          </span>
        </Tooltip>
        <Tooltip title="Cancel">
          <span onClick={closeQuickMsgSection} className="action-icon">
            {redCrossIcon}
          </span>
        </Tooltip>
      </div>
    </section>
  );
};

export default QuickReplySection;
